"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParametersCollection_1 = require("../modules/ParametersCollection");
const rep_common_1 = require("@sa/rep-common");
class DataFlowService {
    constructor(options) {
        var _a;
        this._subscriptions = [];
        this.getParameter = (id) => {
            return this._parameters.get(id);
        };
        this.subscribe = (subscription) => {
            this._subscriptions.push(subscription);
        };
        this.beginBatch = () => {
            if (this._batch !== undefined) {
                throw "already in batch";
            }
            else {
                this._batch = {
                    values: new Map(),
                };
            }
        };
        this.endBatch = () => __awaiter(this, void 0, void 0, function* () {
            if (this._batch === undefined) {
                throw "not in batch";
            }
            else {
                const parametersValues = this._batch.values;
                this._batch = undefined;
                this._update(parametersValues);
            }
        });
        this._onParameterValueChanged = (id, value) => {
            if (this._batch === undefined) {
                const vls = new Map();
                vls.set(id, value);
                this._update(vls);
            }
            else {
                this._batch.values.set(id, value);
            }
        };
        this._update = (parametersValues) => __awaiter(this, void 0, void 0, function* () {
            const state = {
                reportId: this._reportId,
                parameters: parametersValues,
            };
            yield this._pipeline.execute(state);
        });
        this._updateSubscribers = (state) => __awaiter(this, void 0, void 0, function* () {
            const parameters = state.parameters;
            for (const subsciption of this._subscriptions) {
                subsciption(parameters);
            }
            return state;
        });
        this._reportId = options.reportId;
        // init pipeline
        this._pipeline = new rep_common_1.Pipeline(this._updateSubscribers);
        this._parameters = new ParametersCollection_1.ParametersCollection(options.parameters, this._onParameterValueChanged);
        (_a = options.middlewares) === null || _a === void 0 ? void 0 : _a.forEach((x) => this._pipeline.use(x));
    }
    get parameters() {
        return this._parameters;
    }
    subscribeComponent(componentContext) {
        const { canIntegrate, integrated } = componentContext.dataflowIntegration;
        if (canIntegrate && integrated === false) {
            const vals = this.parameters;
            this.subscribe((parameters) => componentContext.update({ values: parameters }));
        }
    }
}
exports.DataFlowService = DataFlowService;
//# sourceMappingURL=DataFlowService.js.map